import React__default, { createContext, useContext, useMemo } from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var getComponentConfigProvider = function getComponentConfigProvider(componentName) {
  var InternalComponentConfig = /*#__PURE__*/createContext({});
  InternalComponentConfig.displayName = "".concat(componentName, "InternalComponentConfig");

  function useInterComponentConfigCtx() {
    return useContext(InternalComponentConfig);
  }

  var InternalComponentConfigProvider = function InternalComponentConfigProvider(_ref) {
    var config = _ref.config,
        children = _ref.children;
    var parentConfig = useInterComponentConfigCtx();
    var value = useMemo(function () {
      return _object_spread({}, parentConfig, config);
    }, [config, parentConfig]);
    return /*#__PURE__*/React__default.createElement(InternalComponentConfig.Provider, {
      value: value
    }, children);
  };

  InternalComponentConfigProvider.displayName = 'InternalComponentConfigProvider';
  return [InternalComponentConfigProvider, useInterComponentConfigCtx, InternalComponentConfig];
};

export { getComponentConfigProvider };